import { AxiosRequestConfig } from 'axios'

const getPrize = (id: string): AxiosRequestConfig => ({
  url: `/prizes/item`,
  method: 'POSt',
  params: {
    id
  }
})

export { getPrize }
